<app-base-generic-questionnaire
  [title]="'TGA.Questionnaire.SoilQuestions.label' | translate"
  [questions]="soilQuestions()"
  (answersUpdated)="answersUpdated($event)"
  [readOnly]="isCropYearReadOnly()"
  [cropYear]="cropYear()"
></app-base-generic-questionnaire>
